import { useMutation } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { syncPartnerAudience } from 'scenes/CustomAudiences/PartnerAudiences/sources/partnerAudiences';

import { syncPA } from '../queryKeyFactory';

export const useSyncPA = () => {
  const syncPAMutation = useMutation(syncPA(), syncPartnerAudience, {
    successMessage: () => `Partner Audience synced`,
  });
  const { showMessage } = useScreenMessage();

  const handleAction = async ({ id, name }) => {
    showMessage(`Start sync Partner Audience`);

    await syncPAMutation.mutateAsync({ id, name });
  };

  return [handleAction, syncPAMutation];
};
